import { useNavigate } from 'react-router-dom';
import type { Flow } from '@/services/flows.api';
import { CopyFlowModal } from './CopyFlowModal';
import { useTemplates } from '../hooks/useTemplates';

/** Start a new flow from `template` and open it in the editor. */
export function UseTemplateModal({ template, onClose }: { template: Flow | null; onClose: () => void }) {
  const navigate = useNavigate();
  const { startFromTemplate } = useTemplates(false);

  return (
    <CopyFlowModal
      opened={!!template}
      onClose={onClose}
      title="New flow from template"
      description="Creates a separate flow. Changes to it never affect the template."
      confirmLabel="Create flow"
      defaultName={template?.name ?? ''}
      onConfirm={async (name) => {
        const flow = await startFromTemplate.mutateAsync({ id: template!.id, name });
        navigate(`/flows/${flow.id}`);
      }}
    />
  );
}
